/**
 * Client context provides application-wide client identification
 * Used primarily for real-time synchronization to prevent duplicate events
 */

// Generate a unique client ID for this browser session
export const CLIENT_ID = crypto.randomUUID();
